import { render, staticRenderFns } from "./CompleteCrossSellBanner.vue?vue&type=template&id=766bffe8"
import script from "./CompleteCrossSellBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteCrossSellBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports